/**
 * Below-stacked player + transcript layout constants.
 * Keep in sync with ``SOFT_BELOW_TRANSCRIPT_MIN_PX`` / transcript panel floors in
 * ``player.tsx`` and ``transcript.tsx``.
 */

/** Minimum transcript panel height when splitting a below stack (drag + soft-fit). */
export const BELOW_STACK_TRANSCRIPT_MIN_PX = 180;

/** Fullscreen video zoom-in may shrink the below transcript to this height. */
export const FULLSCREEN_ZOOM_BELOW_TRANSCRIPT_MIN_PX = 150;

/** Vertical split bar between side-by-side player and transcript (replaces flex gap). */
export const SIDE_STACK_SPLITTER_TOTAL_PX = 28;

/** Minimum transcript column width in a side-by-side split. */
export const SIDE_TRANSCRIPT_MIN_WIDTH_PX = 245;

/** Minimum video-frame column width in a side-by-side split. */
export const SIDE_PLAYER_MIN_WIDTH_PX = 120;

/**
 * Audio has no intrinsic frame, so a max-content side column collapses and the
 * control bar drops volume, speed, and settings (see
 * ``MEDIA_CONTROLS_STACK_WIDTH_PX`` in controls.tsx). Keep the audio column at
 * least this wide so those controls stay on the bar.
 */
export const AUDIO_SIDE_PLAYER_MIN_WIDTH_PX = 340;

/** Minimum video frame height in a below stack split. */
export const BELOW_STACK_VIDEO_MIN_PX = 80;

/**
 * Vertical space consumed by the draggable split bar row between player and
 * transcript (replaces tailwind ``gap-4`` + icon hit target + padding).
 * Subtracted from the transcript-side allocation in soft-fit math.
 */
export const BELOW_STACK_SPLITTER_TOTAL_PX = 28;
